<app-grid
  gridCssClass="readonly-grid {{ gridCssClass }}"
  [stateKey]="gridStateKey"
  [header]="header"
  [columnDefs]="columnDefs"
  [rowData]="rowData"
  [showDelete]="false"
  [pagination]="false"
  [sizeToFit]="sizeToFit"
></app-grid>
